export const transactions = [
  {
    id: 'tx_001',
    organizationId: 'org_3la_labs',
    date: '04/09/2026',
    type: 'entrada',
    description: 'PIX recebido',
    counterparty: 'Empresa XPTO Tecnologia',
    category: 'Serviços',
    amount: 2500,
    bankAccountId: 'bank_nubank',
    bankAccountName: 'Nubank PJ',
    status: 'Conciliado',
  },
  {
    id: 'tx_002',
    organizationId: 'org_3la_labs',
    date: '03/09/2026',
    type: 'saida',
    description: 'PIX enviado',
    counterparty: 'Contabilidade Exata',
    category: 'Administrativo',
    amount: 450,
    bankAccountId: 'bank_bb',
    bankAccountName: 'Banco do Brasil',
    status: 'Conciliado',
  },
  {
    id: 'tx_003',
    organizationId: 'org_3la_labs',
    date: '03/09/2026',
    type: 'saida',
    description: 'PIX enviado',
    counterparty: 'Fornecedor ABC',
    category: 'Administrativo',
    amount: 750,
    bankAccountId: 'bank_nubank',
    bankAccountName: 'Nubank PJ',
    status: 'Conciliado',
  },
  {
    id: 'tx_004',
    organizationId: 'org_3la_labs',
    date: '02/09/2026',
    type: 'entrada',
    description: 'Transferência recebida',
    counterparty: 'Emsoft Solutions',
    category: 'Serviços',
    amount: 1500,
    bankAccountId: 'bank_bb',
    bankAccountName: 'Banco do Brasil',
    status: 'Conciliado',
  },
  {
    id: 'tx_005',
    organizationId: 'org_3la_labs',
    date: '01/09/2026',
    type: 'saida',
    description: 'Débito automático',
    counterparty: 'Hostinger',
    category: 'Infraestrutura',
    amount: 89.9,
    bankAccountId: 'bank_nubank',
    bankAccountName: 'Nubank PJ',
    status: 'Pendente',
  },
  {
    id: 'tx_006',
    organizationId: 'org_3la_labs',
    date: '01/09/2026',
    type: 'entrada',
    description: 'PIX recebido',
    counterparty: 'Agência Horizonte',
    category: 'Consultoria',
    amount: 2500,
    bankAccountId: 'bank_mp',
    bankAccountName: 'Mercado Pago',
    status: 'Conciliado',
  },
  {
    id: 'tx_007',
    organizationId: 'org_3la_labs',
    date: '28/08/2026',
    type: 'saida',
    description: 'Cartão de crédito',
    counterparty: 'Google',
    category: 'Marketing',
    amount: 1200,
    bankAccountId: 'bank_mp',
    bankAccountName: 'Mercado Pago',
    status: 'Conciliado',
  },
  {
    id: 'tx_008',
    organizationId: 'org_3la_labs',
    date: '27/08/2026',
    type: 'entrada',
    description: 'Depósito não identificado',
    counterparty: 'Não identificado',
    category: 'Outros',
    amount: 320,
    bankAccountId: 'bank_bb',
    bankAccountName: 'Banco do Brasil',
    status: 'Não identificado',
  },
];
